import { Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const TooManyRequests = () => {
  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        リクエストが多すぎます
      </Typography>
      <Typography variant="body1" gutterBottom>
        しばらく待ってから再試行してください。
      </Typography>
      <Button variant="contained" component={Link} to="/" sx={{ mt: 4 }}>
        トップに戻る
      </Button>
    </Container>
  );
};

export default TooManyRequests;
